<template>
    <div>
        <!-- ArticlesSections.vue -->
        <HeaderBg title="أقسام فرعية" />
        <Alert 
            v-if="alertToggle == true"
            :acceptedDelete="acceptedDeleteCourse" 
            messege="هل أنت متأكد من مسح القسم   ؟"
        />
        <header class="admin_content_header">
            <h2></h2>
            <div class="search">
                
            </div>
            <router-link :to="'/store-admin/sub-category/'+this.$route.params.id+'/add-sub-category'"> أضف قسم فرعي جديد </router-link>
        </header>

         <div class="divsTable">
            <div class="line_row">
                <h3>الأقسام الفرعية</h3>
            </div>
            <div class="line_row" v-for="sub in subCategory" :key="sub.id">
                <h4>{{sub.translation[0].name}}</h4>
                <div class="actionsContainer">
                    <button :class="sub.is_featured == true ? 'disableBtn' : 'saveBtn'" :disabled="sub.is_featured == true" v-if="postLoaded == false" @click="() => addFeature(sub.id)"> مميز </button>
                    <button :class="sub.is_featured == true ? 'disableBtn' : 'saveBtn'" v-if="postLoaded == true"><b-spinner></b-spinner></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import Alert from '../../global/Alert/Alert';
import Request from '../../../services/Request';
import axios from 'axios';
export default {
    name: 'SubCategory',
    components: {HeaderBg, Alert},
    data(){
        return{
            postLoaded: false,
            subCategory: [],
            deleteID: '',
            alertToggle: false,
        }
    },
    mounted(){
        this.getSubCategory();
        localStorage.removeItem('editSubCategory')
    },
    methods:{
        addFeature(id){
            this.postLoaded = true
            Request.post(`admin/sub-categories/${id}/feature`,'', '')
            .then(() => {
                this.postLoaded = false
                this.getSubCategory();
            })
            .catch(err => {
                this.postLoaded = false
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        getSubCategory(){
            axios.get(`https://app.almujtama.com.sa/admin/subcategory`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    'Authorization': 'Bearer '+ localStorage.getItem('token'),
                },
                params:{
                    category_id : this.$route.params.id
                }
            })
            .then((response) => {
                this.subCategory = response.data.data
            
            })
        },
        editArticleSubCategory(id){
            this.$router.push(`/store-admin/sub-category/${this.$route.params.id}/add-sub-category/${id}`)
            localStorage.setItem('editSubCategory', 'edit')
        },
        deleteData(id){
            this.deleteID = id;
            this.alertToggle = true;
        },
        acceptedDeleteCourse(){
            Request.delete('admin/subcategory',this.deleteID)
            .then( () => {
                this.getSubCategory();
            })
        },
    }
}
</script>
<style lang="scss" scoped>

</style>